import AuthenticatedResource from 'resources/public/AuthenticatedResource'

export default class ApplicationFeeResource extends AuthenticatedResource {
  static urlRoot = '/organizations/:organization_id/application_fee' as const;

  readonly id: number | undefined = undefined;
  
  pk() {
    return this.id?.toString();
  }

}
